<template>
    <div class="page-content">
        <div class="components-box">
            <introduceVue :data="data.hdbjInfo" v-if="!data.hdbjInfo?.disShow"></introduceVue>
            <featureVue :data="data.hdtsInfo" v-if="!data.hdtsInfo?.disShow"></featureVue>
        </div>
        <div class="center-box">
            <div class="components-box">
                <timeVue :data="data.hdsjInfo" v-if="!data.hdsjInfo?.disShow"></timeVue>
            </div>
        </div>
        <div class="components-box">
            <awardsVue :data="data.jxszInfo" v-if="!data.jxszInfo?.disShow"></awardsVue>
            <fieldVue :data="data.hglyInfo" v-if="!data.hglyInfo?.disShow"></fieldVue>
            <rulesVue :data="data.pxgzInfo" v-if="!data.pxgzInfo?.disShow"></rulesVue>
            <committeeVue :data="data.pswyhInfo" v-if="!data.pswyhInfo?.disShow"></committeeVue>
            <organizeVue :data="data.zzjgInfo" v-if="!data.zzjgInfo?.disShow"></organizeVue>
        </div>
    </div>
</template>

<script setup>
import introduceVue from '../components/web/introduce.vue';//活动背景
import featureVue from '../components/web/feature.vue';//活动特色
import timeVue from '../components/web/time.vue';//活动时间
import awardsVue from '../components/web/awards.vue';//奖项设置
import fieldVue from '../components/web/field.vue';//涵盖领域
import rulesVue from '../components/web/rules.vue';//评选规则
import committeeVue from '../components/web/committee.vue';//评审委员会
import organizeVue from '../components/web/organize.vue';//组织机构

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

</script>

<style lang="scss" scoped>
.page-content{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 130px;
    .components-box{
        width: 1065px;
    }
    .center-box{
        width: 100%;
        display: flex;
        justify-content: center;
        background: #fff;
        margin-top: 96px;
        padding: 48px 0;
        .components-box{
            width: 1065px;
        }
    }
}
</style>
